<template>
  <div class="r-add-order">
    <Modal
      :draggable="false"
      footer-hide
      :mask-closable="false"
      :styles="{ top: 0, width: '100%' }"
      v-model="show"
    >
      <div class="title-box">
        <div class="title">{{ $t("shipment.addOrder") }}</div>
        <div @click="close" class="common-hover iconfont iconguanbi"></div>
      </div>
      <div style="width: 1140px; margin: 0 auto">
        <div class="search common-flex common-flex-end">
          <div>
            <Date-picker
              v-model="deliveryDate"
              size="large"
              type="daterange"
              clearable
              placeholder="Finished date"
              style="margin-right: 10px; width: 250px"
              @on-change="onFinishedDateSearch"
            ></Date-picker>

            <Date-picker
              v-model="stockDate"
              size="large"
              type="daterange"
              clearable
              placeholder="Stock date"
              style="margin-right: 10px; width: 250px"
              @on-change="onStockDateSearch"
            >
            </Date-picker>
            <Input
              size="large"
              v-model="params.keywords"
              icon="ios-search"
              clearable
              :placeholder="$t('fabricLibrary.search')"
              style="width: 380px; color: #081938"
              @keyup.enter.native="addOrderShipping"
              @on-clear="addOrderShipping"
            />
            <!-- <Button
              @click="filterClick"
              class="filter"
              size="large"
              type="primary"
            >
              <span class="iconfont iconshaixuan"></span>
              {{ $t("fabricLibrary.filter") }}
            </Button> -->
          </div>
        </div>
      </div>
      <div style="position: relative; text-align: center; padding-bottom: 60px">
        <div class="common-flex common-align-center r-order-add-header">
          <Checkbox
            @on-change="changeAll"
            v-model="allCheck"
            style="flex: 0"
          ></Checkbox>
          <div style="margin: 0 30px 0 10px">序号</div>
          <div class="product" style="flex: 0 0 235px">产品</div>
          <div class="product-cate" style="flex: 0 0 141px">客户名称</div>
          <div style="flex: 0 0 216px">下单时间</div>
          <div style="flex: 0 0 216px">
            <span>备货时间</span>
            <span class="sortIcon" @click="onSortClick('f')">
              <b
                :style="{ color: sort.finishedDateIndex === 1 ? '#000' : '#a5a1a1' }"
                >&#8593;</b
              >
              <b
                :style="{ color: sort.finishedDateIndex === 2 ? '#000' : '#a5a1a1' }"
                >&#8595;</b
              >
            </span>
          </div>
          <div style="flex: 0 0 216px">
            <span>交货时间</span>
            <span class="sortIcon" @click="onSortClick('d')">
              <b
                :style="{ color: sort.deliveryDateIndex === 1 ? '#000' : '#a5a1a1' }"
                >&#8593;</b
              >
              <b
                :style="{ color: sort.deliveryDateIndex === 2 ? '#000' : '#a5a1a1' }"
                >&#8595;</b
              >
            </span>
          </div>
        </div>
        <rOrderAdd
          @changeChoose="changeChoose"
          :index="index"
          :config="item"
          v-for="(item, index) in list"
          :key="index"
        ></rOrderAdd>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <rNull
          v-if="list.length == 0 && spinShow == false"
          imgStyle="width:300px;margin:40px auto"
          titleStyle="font-size:16px;color:#999"
          :title="$t('noResult')"
        ></rNull>
        <Page
          style="margin: 15px 0"
          :total="total"
          @on-change="changePage"
          :page-size="params.pageSize"
          show-sizer
          @on-page-size-change="changeSize"
          show-total
        >
          <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
        </Page>
        <div class="select-all common-flex common-justify-between">
          <Checkbox @on-change="changeAll" v-model="allCheck">
            {{ $t("user.selectAll") }}
          </Checkbox>
          <div>{{ $t("user.check") }}: {{ nums }} {{ $t("user.items") }}</div>
        </div>
      </div>

      <div class="common-flex common-justify-center options">
        <div class="back options-btn common-hover" @click="back">
          {{ $t("order.back") }}
        </div>
        <div
          class="save options-btn common-hover"
          v-if="list.length > 0"
          @click="submit"
        >
          {{ $t("order.submit") }}
        </div>
      </div>
    </Modal>
    <!-- 搜索项 -->
    <!-- <rOrderFilter
      @close="closeFilte"
      :filteShow="orderfilteShow"
    ></rOrderFilter> -->
  </div>
</template>

<script>
import rOrderAdd from "./r-order-add";
import rNull from "./r-null";
// import rOrderFilter from "./r-order-filter";
import { mapActions } from "vuex";
export default {
  name: "r-add-order",
  data() {
    return {
      spinShow: false,
      show: true,
      orderfilteShow: false,
      total: 0,
      nums: 0,
      params: {
        keywords: "",
        startDeliveryDate: "",
        endDeliveryDate: "",
        existOrderId: "",
        deliveryCode: "",
        startInDate: "",
        endInDate: "",
        deliveryDateBy: "",
        inDateBy: "",
        pageSize: 10,
        pageNum: 1,
      },
      list: [],
      allCheck: false,
      deliveryDate: [],
      stockDate: [],
      sort: {
        deliveryDateIndex: 0,
        finishedDateIndex: 0,
      },

      sortType: ["","asc", "desc"]
    };
  },
  components: {
    rOrderAdd,
    rNull,
    // rOrderFilter,
  },
  watch: {
    filteShow: {
      handler(newold, oldval) {
        this.show = newold;
        if (newold) {
          this.params.existOrderId = this.orders;
          console.log(this.params);
          this.addOrderShipping();
        }
        this.params.deliveryCode = this.deliveryCode;
      },
      immediate: true,
    },
    list: {
      handler(newval, oldval) {
        this.nums = 0;
        let pass = true;
        newval.map((item) => {
          if (item.check == false) {
            pass = false;
          } else {
            this.nums++;
          }
        });
        this.allCheck = pass;
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    filteShow: Boolean,
    orders: String,
    deliveryCode: String,
  },
  mounted() {},
  methods: {
    ...mapActions(["addOrderShippingAction"]),
    changeChoose() {
      // console.log('this.list',this.list)
    },
    changeAll() {
      this.list.map((item) => {
        item.check = this.allCheck;
      });
    },
    back() {
      this.show = false;
      this.$emit("back");
    },
    // 修改页数
    changePage(e) {
      this.params.pageNum = e;
      this.addOrderShipping();
    },
    // 修改条数

    changeSize(e) {
      this.params.pageSize = e;
      this.addOrderShipping();
    },
    // 提交
    submit() {
      let arr = [];
      this.list.map((item) => {
        if (item.check) {
          arr.push(item);
        }
      });
      this.$emit("submit", arr);
      // console.log('arr',arr)
    },

    // 新增
    addOrderShipping() {
      this.spinShow = true;
      this.addOrderShippingAction(this.params)
        .then((res) => {
          console.log("res", res);
          res.data.map((item) => {
            item.check = false;
          });
          this.total = res.total;
          this.list = res.data;
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 关闭弹框
    close() {
      this.$emit("close");
    },
    // 显示搜搜分类
    filterClick() {
      this.orderfilteShow = true;
    },
    // 关闭搜索分类
    closeFilte() {
      this.orderfilteShow = false;
    },
    // 交货日期搜索
    onFinishedDateSearch(dates, type) {
      if (dates.length > 0) {
        this.params.startDeliveryDate = dates[0];
        this.params.endDeliveryDate = dates[1];
        this.addOrderShipping();
      }
    },
    // 备货日期搜索
    onStockDateSearch(dates, type) {
      if (dates.length > 0) {
        this.params.startInDate = dates[0];
        this.params.endInDate = dates[1];
        this.addOrderShipping();
      }
    },
    onSortClick(type) {
      if (type === "f") {
        this.params.deliveryDateBy = ''
        this.sort.deliveryDateIndex = 0
        this.sort.finishedDateIndex++;
        if (this.sort.finishedDateIndex >= 3) {
          this.sort.finishedDateIndex = 1;
        }
        this.params.inDateBy = this.sortType[this.sort.finishedDateIndex];

      } else if (type === "d") {
        this.params.inDateBy = ''
        this.sort.finishedDateIndex = 0;
        this.sort.deliveryDateIndex++;
        if (this.sort.deliveryDateIndex >= 3) {
          this.sort.deliveryDateIndex = 1;
        }
        this.params.deliveryDateBy = this.sortType[this.sort.deliveryDateIndex];
      }
      this.addOrderShipping()
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-content {
  border-radius: 0;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.select-all {
  position: absolute;
  height: 46px;
  width: 1140px;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background: #ffffff;
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.04);
  padding: 14px 30px;
}
.search {
  margin-top: 20px;
  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.options {
  position: relative;
  // width: 1130px;
  margin: 20px auto;
  padding-bottom: 25px;
  .options-btn {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    background: #b5bac4;
    margin: 0 7px;
  }
  .save {
    background: #0a4dcc;
  }
}
.r-order-add-header {
  width: 1140px;
  margin: 50px auto 20px;
  padding: 20px 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}
.sortIcon {
  cursor: pointer;
}
.sortIcon b:nth-child(1) {
  margin-right: -10px;
}
.sortIcon b {
  color: #a5a1a1;
}
</style>



// WEBPACK FOOTER //
// src/components/r-add-order.vue